import author1 from "../../assets/images/testimonials/author1.jpg"
import author2 from "../../assets/images/testimonials/author2.jpg"
import author3 from "../../assets/images/testimonials/author3.jpg"
import author4 from "../../assets/images/testimonials/author4.jpg"

export const testimonialsData = [
    {
        id: 1,
        name: "Javier López",
        position: "Seguidor y consumidor de contenido",
        src: author1,
        review: "Los vídeos de Marcus sobre videojuegos son una pasada, siempre trae análisis y teorías interesantes, buenas recomendaciones y encima lo hace de una forma súper divertida. Es de esos creadores que puedes ver por horas sin aburrirte. ¡Un crack total!"
    },
    {
        id: 2,
        name: "Lucía Aguado",
        position: "Seguidora",
        src: author3,
        review: "Tiene un talento único para analizar temas complejos de marketing, enfocados a cualquier ámbito, de forma fácil. Sus videos y posts están siempre cargados de buenas vibras y datos útiles. Un 10 como creador y gestor."
    },
    {
        id: 3,
        name: "Mariona Castles",
        position: "Boundless",
        src: author4,
        review: "Desde la estrategia hasta la ejecución, su enfoque en marketing y redes sociales ha generado resultados concretos para nuestra marca. Las colaboraciones han sido fluidas, y la comunicación impecable. ¡Estamos deseando colaborar de nuevo!"
    },
    {
        id: 4,
        name: "Carolina Yuang",
        position: "Responsable de Marketing, Gearbest",
        src: author2,
        review: "Colaborar con Marcus ha sido una excelente decisión para nuestra estrategia digital. Su experiencia en marketing y capacidad para generar engagement con el público ha incrementado notablemente nuestro alcance. Profesional y muy creativo."
    },
]